import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { IReviewWidgetPagerReview, ReviewWidgetPagerReview } from "./reviewWidgetPagerReview";

export interface IReviewWidgetPagerReviews extends IInstanceComponentBase {
    update: (newReviews: string, clearReviews: boolean) => void;
}

export class ReviewWidgetPagerReviews extends InstanceComponentBase implements IReviewWidgetPagerReviews {
    public reviewWidgetPagerReviewList: IReviewWidgetPagerReview[];

    constructor(public htmlElement: HTMLElement) {
        super(htmlElement);

        this.reviewWidgetPagerReviewListFactory();
    }

    getHtmlElementsReviewWidgetPagerReview():NodeListOf<HTMLElement> {
        let reviewWidgetPagerReviewElements: NodeListOf<HTMLElement> = this.htmlElement.querySelectorAll(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewComponents.reviewWidgetPagerReview))
        return reviewWidgetPagerReviewElements;
    }

    reviewWidgetPagerReviewListFactory():void {
        let reviewWidgetPagerReviewElements = this.getHtmlElementsReviewWidgetPagerReview();
        let reviewList = new Array<ReviewWidgetPagerReview>();
        for(let x = 0; x < reviewWidgetPagerReviewElements.length; x += 1){
            let review = new ReviewWidgetPagerReview(reviewWidgetPagerReviewElements[x]);
            reviewList.push(review);
        }
        this.reviewWidgetPagerReviewList = reviewList;
    }

    updateReviews(newReviews: string):void{
        this.htmlElement.insertAdjacentHTML("beforeend", newReviews);
    }
    
    clearAllReviewsFromHtmlElement():void{
        this.htmlElement.innerHTML = '';
    }

    update(newReviews: string, clearAllReviews: boolean):void{
        this.disposeReviewList();
        if(clearAllReviews){
            this.clearAllReviewsFromHtmlElement();
        }
        this.updateReviews(newReviews);
        this.reviewWidgetPagerReviewListFactory();
    }

    disposeReviewList():void{
        try {
            this.reviewWidgetPagerReviewList.forEach((reviewWidgetPagerReview: IReviewWidgetPagerReview) => {
                reviewWidgetPagerReview.dispose();
            });
            
            this.reviewWidgetPagerReviewList = [];
        } catch (error) {
            console.log('ReviewWidgetPagerReviews disposeReviewList: failed to dispose ERROR: ', error);
        }
    }

    dispose() {
        try {
            console.log(`ReviewWidgetPagerReviews: dispose`);
            
            if (this.reviewWidgetPagerReviewList) {
                this.disposeReviewList();
            }
          
        } catch (error) {
            console.log('ReviewWidgetPagerReviews: dispose ERROR', error);
        }
    }

    delete(): void {
       
    }
}